import { button, folder, useControls } from 'leva'

export default function Controls() {
  return useControls({
    Settings: folder({
      Rendering_Scale: {
        value: window.isFxpreview ? 0.75 : 0.9,
        max: 1,
        min: 0,
        step: 0.1,
        label: 'Resolution',
      },
      Rendering_Bounces: {
        value: 12,
        max: 20,
        min: 1,
        step: 1,
        label: 'Bounces',
      },
      Rendering_Samples: {
        value: 1,
        max: 20,
        min: 1,
        step: 1,
        label: 'FrameSamples',
      },
    }),
    Controls: folder({
      'Take Screenshot': button(() => {
        window.takeScreenshot()
      }),

      Rendering: {
        value: true,
      },
    }),
  })
}
